/* Ishwar Tattva v2: pop-in product images, swipeable hero and rails, tabs. Text is never hidden. */
(function(){
  var d=document,root=d.documentElement;
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.classList.add('itx-js');window.itxReady=1;

  /* Pop-in for product and image cards. Anything already on screen, or in a sideways rail, shows at once. */
  var io='IntersectionObserver' in window?new IntersectionObserver(function(es){
    es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});
  },{rootMargin:'0px 200px 120px 200px',threshold:0}):null;
  function watch(scope){
    (scope||d).querySelectorAll('.itx-pop,.product-grid>.grid__item,.itx-popgrid>*').forEach(function(el){
      if(el.dataset.itxW)return;el.dataset.itxW=1;
      var p=el.parentElement,sib=p?Array.prototype.indexOf.call(p.children,el):0;
      if(!el.style.getPropertyValue('--d'))el.style.setProperty('--d',(sib%4*0.05)+'s');
      if(io&&!reduce)io.observe(el);else el.classList.add('is-in');
    });
  }
  /* Safety net: never leave anything invisible */
  setTimeout(function(){d.querySelectorAll('.itx-pop,.product-grid>.grid__item,.itx-popgrid>*').forEach(function(el){
    var r=el.getBoundingClientRect();if(r.top<window.innerHeight)el.classList.add('is-in');});},2500);

  /* Dots that follow a scroll-snap track */
  function dotsFor(track,box,count){
    if(!box)return function(){};
    box.innerHTML='';for(var k=0;k<count;k++){var i=d.createElement('i');box.appendChild(i);}
    var dots=box.children;
    return function(n){for(var k=0;k<dots.length;k++)dots[k].classList.toggle('is-on',k===n);};
  }

  /* Swipe helper: follows the finger only once the gesture is clearly sideways, so vertical scrolling is never caught */
  function swipe(el,o){
    var x0=null,y0=0,dx=0,lock=0,mouse=false;
    function start(x,y){x0=x;y0=y;dx=0;lock=0;o.start&&o.start()}
    function move(x,y,e){if(x0===null)return;dx=x-x0;var dy=y-y0;
      if(!lock&&(Math.abs(dx)>8||Math.abs(dy)>8))lock=Math.abs(dx)>Math.abs(dy)?1:2;
      if(lock===1){if(e&&e.cancelable)e.preventDefault();o.move&&o.move(dx)}}
    function end(){if(x0===null)return;var was=lock===1;x0=null;o.end&&o.end(was?dx:0,was);if(was)el._swiped=Date.now()}
    el.addEventListener('touchstart',function(e){start(e.touches[0].clientX,e.touches[0].clientY)},{passive:true});
    el.addEventListener('touchmove',function(e){move(e.touches[0].clientX,e.touches[0].clientY,e)},{passive:false});
    el.addEventListener('touchend',end,{passive:true});el.addEventListener('touchcancel',end,{passive:true});
    el.addEventListener('pointerdown',function(e){if(e.pointerType!=='mouse'||e.button)return;mouse=true;start(e.clientX,e.clientY)});
    window.addEventListener('pointermove',function(e){if(mouse)move(e.clientX,e.clientY)});
    window.addEventListener('pointerup',function(){if(mouse){mouse=false;end()}});
    el.addEventListener('click',function(e){if(el._swiped&&Date.now()-el._swiped<400){e.preventDefault();e.stopPropagation()}},true);
    el.addEventListener('dragstart',function(e){e.preventDefault()});
  }

  /* Hero: slides crossfade in place; swipe responds on the first touch; dots; gentle autoplay */
  function hero(el){
    if(el.dataset.itxH)return;el.dataset.itxH=1;
    var track=el.querySelector('.itx-hero__track'),slides=el.querySelectorAll('.itx-hero__slide'),dots=el.querySelectorAll('.itx-hero__dot');
    if(!track||!slides.length)return;
    var n=slides.length,i=0,t,ms=6000;
    function go(k){i=(k+n)%n;slides.forEach(function(s,j){s.classList.toggle('is-on',j===i);s.setAttribute('aria-hidden',j===i?'false':'true');s.tabIndex=j===i?0:-1});
      dots.forEach(function(b,j){b.classList.toggle('is-on',j===i);b.setAttribute('aria-current',j===i?'true':'false')});
      var nx=slides[(i+1)%n].querySelector('img');if(nx)nx.loading='eager';}
    function auto(){clearTimeout(t);if(!reduce&&n>1)t=setTimeout(function(){if(!d.hidden&&!el.classList.contains("is-paused"))go(i+1);auto()},ms)}
    dots.forEach(function(b,k){b.addEventListener('click',function(){go(k);auto()})});
    if(n>1)swipe(track,{start:function(){clearTimeout(t)},
      move:function(dx){var im=slides[i].querySelector('img');if(im){el.classList.add('is-drag');im.style.transform='translate3d('+(dx*.12)+'px,0,0) scale(1.02)'}},
      end:function(dx){var im=slides[i].querySelector('img');el.classList.remove('is-drag');if(im)im.style.transform='';
        if(Math.abs(dx)>40)go(i+(dx<0?1:-1));auto()}});
    go(0);auto();
  }

  /* Rails: drag on desktop, arrows that wrap round, dot progress, optional auto-slide (Orra-style) */
  function rail(el){
    if(el.dataset.itxR)return;el.dataset.itxR=1;
    var wrap=el.closest('[data-itx-railwrap]')||el.parentElement;
    var prev=wrap.querySelector('[data-prev]'),next=wrap.querySelector('[data-next]');
    function step(){var c=el.firstElementChild;if(!c)return 300;var g=parseFloat(getComputedStyle(el).columnGap)||12;return c.getBoundingClientRect().width+g}
    function max(){return el.scrollWidth-el.clientWidth}
    function fwd(){if(el.scrollLeft>=max()-4)el.scrollTo({left:0});else el.scrollBy({left:step()})}
    function back(){if(el.scrollLeft<=4)el.scrollTo({left:max()});else el.scrollBy({left:-step()})}
    prev&&prev.addEventListener('click',function(){back();hold()});
    next&&next.addEventListener('click',function(){fwd();hold()});
    var box=wrap.querySelector('.itx-progress'),pages=0,set=function(){};
    function build(){var n=Math.max(1,Math.round(max()/step())+1);if(max()<4)n=0;if(n!==pages){pages=n;set=dotsFor(el,box,n);}upd();}
    function upd(){var m=max();set(m>0?Math.round(el.scrollLeft/m*(pages-1)):0);}
    el.addEventListener('scroll',upd,{passive:true});window.addEventListener('resize',build);build();
    /* Auto-glide: a slow, continuous drift (about 18px a second) that eases in, turns round gently at each end,
       and stops only when the rail is touched, dragged, wheeled, focused or its arrows are used; it eases back in 3s later.
       Hovering does not stop it. data-autoplay="0" on the rail wrapper switches it off. */
    var glide=!reduce&&wrap.dataset.autoplay!=='0',vis=false,pause=0,pos=0,dir=1,cur=0,last=0;
    function hold(ms){pause=performance.now()+(ms||4000);cur=0;el.classList.remove('is-glide')}
    function frame(t){var dt=last?Math.min(t-last,50):16;last=t;var m=max();
      if(vis&&m>4&&t>pause&&!d.hidden&&!down){
        if(!el.classList.contains('is-glide')){el.classList.add('is-glide');pos=el.scrollLeft}
        if(Math.abs(el.scrollLeft-pos)>2)pos=el.scrollLeft;
        cur+=(1-cur)*Math.min(1,dt/1200);
        pos+=dir*0.018*cur*dt;
        if(pos>=m){pos=m;dir=-1;cur=0}else if(pos<=0){pos=0;dir=1;cur=0}
        el.scrollLeft=pos;
      }
      requestAnimationFrame(frame)}
    if(glide){
      if('IntersectionObserver' in window)new IntersectionObserver(function(es){vis=es[0].isIntersecting},{threshold:.2}).observe(el);else vis=true;
      ['touchstart','pointerdown','wheel','focusin'].forEach(function(ev){wrap.addEventListener(ev,function(){hold(4000)},{passive:true})});
      ['touchend','pointerup'].forEach(function(ev){wrap.addEventListener(ev,function(){hold(3000)},{passive:true})});
      requestAnimationFrame(frame);
    }
    var down=false,x0=0,s0=0,moved=false;
    el.addEventListener('pointerdown',function(e){if(e.pointerType!=='mouse')return;down=true;moved=false;x0=e.clientX;s0=el.scrollLeft;});
    window.addEventListener('pointermove',function(e){if(!down)return;var dx=e.clientX-x0;if(Math.abs(dx)>4){moved=true;el.classList.add('is-drag');el.style.scrollBehavior='auto';}el.scrollLeft=s0-dx;});
    window.addEventListener('pointerup',function(){if(!down)return;down=false;el.classList.remove('is-drag');el.style.scrollBehavior='';});
    el.addEventListener('click',function(e){if(moved){e.preventDefault();moved=false;}},true);
    el.addEventListener('dragstart',function(e){e.preventDefault()});
  }

  /* Product card photo sliders: photos glide one after another while the card is on screen; swipe in grids; arrows on desktop */
  var cio='IntersectionObserver' in window?new IntersectionObserver(function(es){
    es.forEach(function(e){var c=e.target._itx;if(c)c.vis(e.isIntersecting)});
  },{threshold:.55}):null;
  var cn=0;
  function cslide(el){
    if(el.dataset.itxC)return;el.dataset.itxC=1;
    var tr=el.querySelector('.itx-card__track');if(!tr)return;
    var imgs=tr.querySelectorAll('img'),n=imgs.length,dots=el.querySelectorAll('.itx-card__dots i'),i=0,t=null,hover=false,loaded=false,ord=cn++;
    if(n<2)return;
    function load(){if(loaded)return;loaded=true;imgs.forEach(function(m){m.loading='eager'})}
    function mark(k){dots.forEach(function(x,j){x.classList.toggle('is-on',j===k)})}
    function go(k){load();i=(k+n)%n;tr.style.transform='translate3d('+(-i*100)+'%,0,0)';mark(i)}
    function stop(){clearInterval(t);clearTimeout(t);t=null}
    function run(ms,first){stop();if(reduce)return;t=setTimeout(function(){go(i+1);t=setInterval(function(){go(i+1)},ms)},first)}
    el._itx={vis:function(v){if(v){load();run(4200,1200+(ord%4)*700)}else stop()}};
    if(cio)cio.observe(el);
    el.querySelectorAll('.itx-card__nav').forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();
      go(i+(b.classList.contains('itx-card__nav--prev')?-1:1));run(4200,5000)})});
    var card=el.closest('.itx-card')||el;
    if(window.matchMedia('(hover: hover)').matches)card.addEventListener('mouseenter',load);
    /* swipe (outside sideways rails, where a swipe moves the rail) */
    if(!el.closest('.itx-rail')){
      el.style.touchAction='pan-y';
      var x0=null,y0=0,sw=false;
      el.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;y0=e.touches[0].clientY;sw=false},{passive:true});
      el.addEventListener('touchmove',function(e){if(x0===null)return;var dx=e.touches[0].clientX-x0,dy=e.touches[0].clientY-y0;
        if(!sw&&Math.abs(dx)>14&&Math.abs(dx)>Math.abs(dy)){sw=true;stop()}},{passive:true});
      el.addEventListener('touchend',function(e){if(x0===null)return;var dx=e.changedTouches[0].clientX-x0;x0=null;
        if(sw&&Math.abs(dx)>34){go(i+(dx<0?1:-1));run(4200,5000)}});
      card.addEventListener('click',function(e){if(sw){e.preventDefault();sw=false}},true);
    }
  }

  /* Collection carousel (Orra-style): one banner centred, neighbours peeking, glide and fade */
  function stage(el){
    if(el.dataset.itxS)return;el.dataset.itxS=1;
    var slides=[].slice.call(el.querySelectorAll('.itx-stage__slide')),n=slides.length;if(!n)return;
    var sec=el.closest('section')||el.parentElement,prev=sec.querySelector('[data-prev]'),next=sec.querySelector('[data-next]');
    var set=dotsFor(el,sec.querySelector('.itx-progress'),n>1?n:0),i=0,vis=false,paused=0,ms=6500;
    function draw(){slides.forEach(function(s,k){var d=k-i;if(d>n/2)d-=n;if(d<-n/2)d+=n;
      s.style.setProperty('--p',d);s.classList.toggle('is-on',d===0);s.classList.toggle('is-near',Math.abs(d)===1);
      s.setAttribute('aria-hidden',d===0?'false':'true');s.tabIndex=d===0?0:-1;});set(i)}
    function go(k){i=(k+n)%n;draw()}
    function hold(){paused=Date.now()+7000}
    prev&&prev.addEventListener('click',function(){go(i-1);hold()});
    next&&next.addEventListener('click',function(){go(i+1);hold()});
    var box=sec.querySelector('.itx-progress');
    box&&box.addEventListener('click',function(e){var k=[].indexOf.call(box.children,e.target);if(k>-1){go(k);hold()}});
    slides.forEach(function(s,k){s.addEventListener('click',function(e){if(k!==i){e.preventDefault();go(k);hold()}})});
    swipe(el,{start:hold,move:function(dx){el.classList.add('is-drag');var c=slides[i];c.style.transform='translate3d('+(dx*.35)+'px,0,0)'},
      end:function(dx){el.classList.remove('is-drag');slides[i].style.transform='';if(Math.abs(dx)>40)go(i+(dx<0?1:-1));hold()}});
    if(ms>0&&!reduce&&n>1){
      if('IntersectionObserver' in window)new IntersectionObserver(function(es){vis=es[0].isIntersecting},{threshold:.4}).observe(el);else vis=true;
      setInterval(function(){if(vis&&Date.now()>paused&&!d.hidden)go(i+1)},ms);
    }
    draw();el.classList.add('is-ready');
  }

  /* Close-up ribbon: drifts slowly, stops when touched, resumes after a pause; loops seamlessly (content is doubled) */
  function strip(el){
    if(el.dataset.itxP)return;el.dataset.itxP=1;
    var sp=parseFloat(el.dataset.speed);if(isNaN(sp))sp=2;var v=sp*0.012,pos=0,last=0,pause=0,vis=false,run=el.querySelector('.itx-strip__run');
    function half(){return run?run.getBoundingClientRect().width:0}
    function hold(ms){pause=performance.now()+(ms||2500)}
    function frame(t){var dt=last?Math.min(t-last,50):16;last=t;
      if(vis&&!reduce&&v>0&&t>pause&&!d.hidden){var h=half();if(Math.abs(el.scrollLeft-pos)>2)pos=el.scrollLeft;pos+=v*dt;if(h&&pos>=h)pos-=h;el.scrollLeft=pos}
      requestAnimationFrame(frame)}
    el.addEventListener('scroll',function(){var h=half();if(h&&el.scrollLeft>=h)el.scrollLeft-=h},{passive:true});
    ['touchstart','pointerdown','wheel','focusin'].forEach(function(e){el.addEventListener(e,function(){hold(3500)},{passive:true})});
    if('IntersectionObserver' in window)new IntersectionObserver(function(es){vis=es[0].isIntersecting},{threshold:0}).observe(el);else vis=true;
    /* desktop drag */
    var down=false,x0=0,s0=0,moved=false;
    el.addEventListener('pointerdown',function(e){if(e.pointerType!=='mouse')return;down=true;moved=false;x0=e.clientX;s0=el.scrollLeft});
    window.addEventListener('pointermove',function(e){if(!down)return;var dx=e.clientX-x0;if(Math.abs(dx)>4){moved=true;el.classList.add('is-drag')}el.scrollLeft=s0-dx});
    window.addEventListener('pointerup',function(){if(down){down=false;el.classList.remove('is-drag')}});
    el.addEventListener('click',function(e){if(moved){e.preventDefault();moved=false}},true);
    el.addEventListener('dragstart',function(e){e.preventDefault()});
    requestAnimationFrame(frame);
  }

  /* Mala builder: a light counts round the beads; tapping a wood re-strings the mala in a wave from the guru bead */
  function build(el){
    if(el.dataset.itxB)return;el.dataset.itxB=1;
    var beads=[].slice.call(el.querySelectorAll('.itx-build__b img')),tbs=[].slice.call(el.querySelectorAll('.itx-build__t img')),
      guru=el.querySelector('.itx-build__guru img'),sum=el.querySelector('.itx-build__sumeru img'),woods=el.querySelectorAll('.itx-build__wood'),
      name=el.querySelector('.itx-build__name'),go=el.querySelector('.itx-build__go'),link=el.dataset.link||'/pages/design-your-mala',
      n=beads.length,cur=0,touched=false,vis=false,cyc=(parseFloat(el.dataset.cycle)||0)*1000,lit=0;
    function href(key){try{return link+'#design='+btoa(JSON.stringify({v:1,mix:'one',primary:key})).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'')}catch(e){return link}}
    function swapImg(img,src,delay){if(!img||!src)return;setTimeout(function(){var p=img.parentNode;p.classList.add('is-out');
      setTimeout(function(){img.src=src;p.classList.remove('is-out')},reduce?0:300)},reduce?0:delay)}
    function pick(k){if(k===cur&&el.dataset.itxBs)return;el.dataset.itxBs=1;cur=k;var w=woods[k];if(!w)return;
      woods.forEach(function(b,j){b.classList.toggle('is-on',j===k);b.setAttribute('aria-pressed',j===k?'true':'false')});
      /* wave: guru, sumeru and tassel first, then the beads nearest the guru, both sides at once */
      swapImg(guru,w.dataset.guru,0);swapImg(sum,w.dataset.sumeru,60);
      tbs.forEach(function(img,j){swapImg(img,w.dataset.tbead||w.dataset.bead,120+(j%3)*60)});
      beads.forEach(function(img,j){var dist=Math.min(j+1,n-j);swapImg(img,w.dataset.bead,dist*40)});
      if(name){name.classList.add('is-swap');setTimeout(function(){name.querySelector('[data-name]').textContent=w.dataset.name;name.classList.remove('is-swap')},300)}
      if(go)go.href=href(w.dataset.key)}
    woods.forEach(function(b,k){b.addEventListener('click',function(){touched=true;pick(k)})});
    if(go&&woods[0])go.href=href(woods[0].dataset.key);
    if('IntersectionObserver' in window)new IntersectionObserver(function(es){vis=es[0].isIntersecting;if(vis)beads.forEach(function(m){m.loading='eager'})},{threshold:.3}).observe(el);else vis=true;
    if(!reduce&&n){setInterval(function(){if(!vis||d.hidden)return;var a=beads[lit];if(a)a.parentNode.classList.remove('is-lit');
      lit=(lit+1)%n;beads[lit].parentNode.classList.add('is-lit')},420)}
    if(cyc>0&&!reduce)setInterval(function(){if(vis&&!touched&&!d.hidden)pick((cur+1)%woods.length)},cyc);
  }

  /* Tabs */
  function tabs(el){
    var t=el.querySelectorAll('[role=tab]');
    t.forEach(function(b){b.addEventListener('click',function(){
      t.forEach(function(x){x.setAttribute('aria-selected','false');var p=d.getElementById(x.getAttribute('aria-controls'));if(p)p.hidden=true;});
      b.setAttribute('aria-selected','true');var p=d.getElementById(b.getAttribute('aria-controls'));
      if(p){p.hidden=false;watch(p);p.querySelectorAll('.itx-rail').forEach(rail);}
    })});
  }

  function slots(scope){(scope||d).querySelectorAll('.itx-slot').forEach(function(s){if(!s.querySelector('img,video,iframe'))s.setAttribute('data-empty','')})}

  function init(scope){
    scope=scope||d;
    scope.querySelectorAll('.itx-hero').forEach(hero);
    scope.querySelectorAll('.itx-rail').forEach(function(r){if(!r.closest('[hidden]'))rail(r)});
    scope.querySelectorAll('[data-itx-tabs]').forEach(tabs);
    scope.querySelectorAll('[data-itx-cslide]').forEach(cslide);
    scope.querySelectorAll('[data-itx-stage]').forEach(stage);
    scope.querySelectorAll('[data-itx-strip]').forEach(strip);
    scope.querySelectorAll('[data-itx-build]').forEach(build);
    slots(scope);watch(scope);footDots();
  }
  /* Footer menus on phones: a dot between links, none at the start of a wrapped line */
  function footDots(){d.querySelectorAll('.itx-foot__menus ul').forEach(function(u){var prev=null;
    [].forEach.call(u.children,function(li){li.classList.remove('is-ls')});
    [].forEach.call(u.children,function(li){if(prev&&li.offsetTop>prev.offsetTop+4)li.classList.add('is-ls');prev=li})})}
  var fdt;window.addEventListener('resize',function(){clearTimeout(fdt);fdt=setTimeout(footDots,150)});
  window.addEventListener('load',footDots);
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',function(){init()});else init();
  d.addEventListener('shopify:section:load',function(e){init(e.target)});
  var mt;new MutationObserver(function(){clearTimeout(mt);mt=setTimeout(function(){watch();d.querySelectorAll('[data-itx-cslide]').forEach(cslide)},120)}).observe(d.body||root,{childList:true,subtree:true});
})();